import $ from 'jquery';

/**
 * script hover button show text
 * **/
$('.c-btn1__link').hover(
  function () {
    $(this).addClass('is-active');
    $('.c-btn1__link').not(this).addClass('is-inactive');
    $(this).parent().addClass('is-hover');
  },
  function () {
    $(this).removeClass('is-active');
    $(this).parent().removeClass('is-hover');
    $('.c-btn1__link').not(this).removeClass('is-inactive');
  }
);
/**
 * script click button navbar show menu
 * **/
var scrollTop = 0;
$('.js-navbar').on("click", function () {
  const header = $('.c-header');

  if (header.hasClass('is-show')) {
    header.removeClass('is-show');

    setTimeout(function () {
      $("body").css({
        position: "",
        top: "",
        left: "",
        right: ""
      });
      $(window).scrollTop(scrollTop);
    }, 100);

  } else {
    header.addClass('is-show');

    setTimeout(function () {
      scrollTop = $(window).scrollTop();
      const fixedScrollTop = -scrollTop;
      $("body").css({
        position: "fixed",
        top: fixedScrollTop,
        left: 0,
        right: 0
      });
    }, 100);

  }
});

/**
 * script click button plus show menu
 * **/

$(".js-menu-plus").on("click", function () {
  const vw = $(window).innerWidth();
  if (vw < 1301) {
    $(this).toggleClass("is-open");
    $(this).next().slideToggle();
  }
});

/**
 * script scroll header
 * **/
let scrollendTimer, numberh;
let scrollPosPrev = 0;

$(window).on("scroll", function () {
  const footerTop = $('.c-footer').offset().top;
  const header = $(".c-header");
  let scrollPos = $(window).scrollTop();
  if ($(window).outerWidth() < 768) {
    numberh = 0;
  } else {
    numberh = 0;
  }
  if (scrollPos > 100) {
    let _diff = scrollPos - scrollPosPrev;
    if (_diff > 0) {
      header.addClass("is-hidden");
    } else {
      if (scrollPos < footerTop - numberh) {
        header.removeClass('is-hidden');
      } else {
        header.addClass('is-hidden');
      }
    }
    scrollPosPrev = scrollPos;
    clearTimeout(scrollendTimer);
    scrollendTimer = setTimeout(function () {
      if (scrollPos < footerTop - numberh) {
        header.removeClass("is-hidden");
      } else {
        header.addClass('is-hidden');
      }
    }, 200);
  }

  // if (scrollPos > 200) {
  //   header.addClass("is-bg");
  //   header.removeClass("is-bg-none");
  // } else {
  //   header.removeClass("is-bg");
  //   header.addClass("is-bg-none");
  // }

});

$(function () {
  if ($(".c-mv1").length) {
    if ($(window).scrollTop() > $(".js-section1").offset().top) {
      $(".c-header").removeClass("is-logo-white");
    } else {
      $(".c-header").addClass("is-logo-white");
    }
  }
})

$(window).on("load scroll", function (e) {
  if ($(".c-mv1").length) {
    if ($(window).scrollTop() > $(".js-section1").offset().top) {
      $(".c-header").removeClass("is-logo-white");
    } else {
      $(".c-header").addClass("is-logo-white");
    }
  }
})
